import { render, staticRenderFns } from "./BankNameTohobank.vue?vue&type=template&id=92325f8c&scoped=true&"
import script from "./BankNameTohobank.vue?vue&type=script&lang=ts&"
export * from "./BankNameTohobank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92325f8c",
  null
  
)

export default component.exports